//
//
//
//
//
//
//
//
//
//
//

import GQL from './gql'
import Graphs from '@/views/services/health/Graphs'
// import Speedtest from '@/views/services/health/Speedtest'

export default {
  components: {
    Graphs
    // Speedtest
  },

  // apollo: {
  //   service: GQL.service
  // },

  data() {
    return {
      // service: {}
    }
  }

  // computed: {
  //   speedtests() {
  //     return this.service?.speedtests || []
  //   }
  // }
}
